import { fmtPct, tone, slug } from "@/lib/format";
import { LtpCell } from "./LtpCell";
import { StatusBadge } from "./StatusBadge";

export const CommoditiesStrip = ({ rows, onOpen }) => {
  if (!rows || rows.length === 0) return null;
  return (
    <section data-testid="commodities-strip" className="space-y-1.5">
      <div className="flex items-center gap-2 px-0.5">
        <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-amber-400">Commodities · MCX</span>
        <span className="font-mono text-[9px] text-slate-600">near-expiry futures</span>
      </div>
      <div className="scroll-thin -mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
        {rows.map((r, i) => (
          <button
            key={r.instrument_token}
            data-testid={`commodity-card-${slug(r.name)}`}
            onClick={() => onOpen(r)}
            style={{ animationDelay: `${i * 30}ms` }}
            className="rise group min-w-[170px] shrink-0 rounded-md border border-amber-900/40 bg-[#14110B] px-3 py-2.5 text-left transition-colors hover:border-amber-600/60"
          >
            <div className="flex items-center justify-between gap-2">
              <span className="truncate text-[11px] font-semibold uppercase tracking-wider text-amber-200/80 group-hover:text-amber-100">
                {r.name}
              </span>
              <span className="font-mono text-[9px] text-slate-600">{r.expiry?.slice(5) || "MCX"}</span>
            </div>
            <div className="mt-1 flex items-baseline justify-between gap-2">
              <LtpCell value={r.ltp} className="text-base font-semibold text-slate-100" />
              <span className={`num text-xs font-semibold ${tone(r.change_pct)}`}>{fmtPct(r.change_pct)}</span>
            </div>
            <div className="mt-1.5 flex items-center justify-between">
              <span className="num text-[10px] text-slate-600">
                H {r.ohlc?.high?.toFixed(1) ?? "—"} · L {r.ohlc?.low?.toFixed(1) ?? "—"}
              </span>
              {r.status !== "live" && <StatusBadge status={r.status} />}
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};
